<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication" id="dedication">
<p class="dedication"><a id="page-vii"></a>This book is dedicated to all of the furry kid moms and dads out there. Hug those furry little beasties for me!</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5622d0e4